import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function OrdinalsJpeg({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><g id="Group"><rect id="Rectangle" x={1} y={1} width={18} height={18} rx={2.25} stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /><path vectorEffect="non-scaling-stroke" id="Path" d="M19 13L15.3628 9.16409C15.269 9.06343 15.1376 9.00627 15 9.00627C14.8624 9.00627 14.731 9.06343 14.6372 9.16409L11 13L6.36119 8.15425C6.26687 8.05572 6.1364 8 6 8C5.8636 8 5.73313 8.05572 5.63881 8.15425L1 13" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></g></Svg>;
}
export default OrdinalsJpeg;